import { render, staticRenderFns } from "./FloodingTab.vue?vue&type=template&id=4128d052&scoped=true&"
import script from "./FloodingTab.vue?vue&type=script&lang=js&"
export * from "./FloodingTab.vue?vue&type=script&lang=js&"
import style1 from "./FloodingTab.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4128d052",
  null
  
)

export default component.exports